import React, { useEffect } from "react"
import { createRoot } from "react-dom/client"
import { Toaster, toast } from "sonner"

// Isola React per i toast: stessa libreria e stesse opzioni dell'originale (App.js: position="bottom-right" richColors).
// Il resto dell'app chiama window.toast.success(…) / .error(…) / .info(…) / .warning(…) / .message(…).
// Al caricamento completo di una pagina un toast (flash del server) puo' arrivare prima che <Toaster> sia montato:
// sonner non ripete a un Toaster nuovo i toast gia' chiamati, quindi fino ad allora window.toast li mette in coda e
// li passa a sonner appena il Toaster ascolta (l'effetto del contenitore gira dopo quello del Toaster).
let mounted = false

function inCoda(coda) {
  const metti = (metodo) => (...args) => { coda.push([metodo, args]) }
  const finto = metti(null)
  Object.keys(toast).forEach((k) => { if (typeof toast[k] === "function") finto[k] = metti(k) })
  return finto
}

function Pronto({ onPronto, children }) {
  useEffect(() => { onPronto() }, [])
  return children
}

export function mountToaster() {
  if (mounted) return
  let host = document.getElementById("erogo-toaster")
  if (!host) {
    host = document.createElement("div")
    host.id = "erogo-toaster"
    host.setAttribute("data-turbo-permanent", "")
    document.body.appendChild(host)
  }
  const coda = []
  window.toast = inCoda(coda)
  const pronto = () => {
    window.toast = toast
    coda.splice(0).forEach(([metodo, args]) => (metodo ? toast[metodo] : toast)(...args))
  }
  createRoot(host).render(<Pronto onPronto={pronto}><Toaster position="bottom-right" richColors /></Pronto>)
  mounted = true
}
